module.exports = __webpack_public_path__ + "23e9dd7239bbae22e49990931d63d81e.png";